import React, { useContext, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import { Button, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const SignInPage = () => {
  const { dispatch, user } = useContext(AuthContext);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLogin = () => {
    if (!username || !password) {
      setError('Username and password are required');
    }
    username && password && setLoading(true);
    setTimeout(() => {
      setLoading(false);
      console.log('Login successful');
      if (!username || !password) {
        setError('Username and password are required');
      } else if (
        username !== process.env.REACT_APP_PLR ||
        password !== process.env.REACT_APP_DFL
      ) {
        setError('Incorrect username or password');
      } else {
        navigate('/');
        dispatch({ type: 'LOGIN_SUCCESS', payload: '1232' });
        const loginTimestamp = new Date().getTime(); // Current time in ms
        localStorage.setItem('loginTimestamp', loginTimestamp);

        console.log('Login successful');
      }
    }, 4000);
  };
  console.log('user', user);
  const handlePassword = (e) => {
    console.log(e.target.value);
    setPassword(e.target.value);
    setError('');
  };
  const handleUsername = (e) => {
    setUsername(e.target.value);
    setError('');
  };
  return (
    <div style={styles.container}>
      <div style={styles.formContainer}>
        <h2>Sign In</h2>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={handleUsername}
          style={styles.input}
          autoComplete="off"
        />
        <input
          type="password"
          placeholder="Password"
          autoComplete="new-password"
          value={password}
          onChange={(e) => handlePassword(e)}
          style={styles.input}
        />
        <Button
          sx={{ mt: 3 }}
          variant="contained"
          onClick={handleLogin}
          endIcon={loading && <CircularProgress color="white" size={'20px'} />}
        >
          Login
        </Button>

        {error && <p style={styles.error}>{error}</p>}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: 'rgb(240, 245, 249)',
    color: '#558fca',
  },
  formContainer: {
    padding: '20px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    width: '400px',
    position: 'relative',
    paddingBottom: '40px',
  },
  input: {
    width: '100%',
    padding: '12px',
    fontSize: '14px',
    margin: '8px 0',
    boxSizing: 'border-box',
    // borderRadius: '5px',
  },
  button: {
    backgroundColor: '#007bff',
    color: 'white',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  error: {
    color: 'red',
    marginTop: '10px',
    position: 'absolute',
    bottom: '0px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
  },
};

export default SignInPage;
